export default "__VITE_ASSET__63b1059f__"